import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { WebSocketProvider } from './components/WebSocketContext';
import { SnackbarProvider } from './Utils/SnackBarContext';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import FileViewerProvider from './components/Viewer/FileViewerProvider';

// Chrome reports this benign layout notification as a window error. CRA's
// development overlay then renders it as a fatal application error.
if (process.env.NODE_ENV === 'development') {
  const resizeObserverLoopMessages = new Set([
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
  ]);

  window.addEventListener('error', (event) => {
    if (!resizeObserverLoopMessages.has(event.message)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <WebSocketProvider>
      <FileViewerProvider>
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </FileViewerProvider>
    </WebSocketProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
